import { defineComponent } from '@vue/composition-api';
import { variant, direction } from './types.js';

var script = defineComponent({
    name: 'SdsTooltip',
    props: {
        variant: {
            type: String,
            required: false,
            default: 'primary',
            validator: function (value) { return variant.includes(value); },
        },
        pointer: {
            type: String,
            required: true,
            validator: function (value) { return direction.includes(value); },
        },
    },
});

export default script;
